import { all, take, takeLatest, race, put, select } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import config from '@config'
import { getToken, getLocale, getCustomData } from '@global/selectors'

import { blockSaveCustomData } from '../../../../../../../../../../../components/Workspace/components/HocBlock/actions'

import {
    LOAD_WON_TENDERS_TABLE_DATA,
    WON_TENDERS_TABLE_LOADING_TRUE,
    WON_TENDERS_TABLE_LOADING_FALSE,
    WON_TENDERS_TABLE_DATA_RECEIVED,
    WON_TENDERS_TABLE_LOADING_FAILED,
    LOAD_WON_TENDERS_TABLE_DATA_REQUEST,
} from './constants'

import {
    tableLoadingTrue,
    tableDataReceived,
    tableLoadingFalse,
    loadTableDataRequest,
    tableLoadingFailed,
} from './actions'

const LOAD_WON_TENDERS_TABLE_DATA_REQUEST_SUCCESS = (id) => `${LOAD_WON_TENDERS_TABLE_DATA_REQUEST(id)}_${SUCCESS}`
const LOAD_WON_TENDERS_TABLE_DATA_REQUEST_FAILED = (id) => `${LOAD_WON_TENDERS_TABLE_DATA_REQUEST(id)}_${FAILED}`

function* loadTableDataSaga(action) {
    const block = action?.data?.block
    if (block !== config.modules.report.blocks.procurement.key) return null

    const module = action?.data?.module
    const entId = action?.data?.entId
    if (!module || !entId) return null

    const level = action?.data?.level
    const locale = yield select(getLocale)
    const token = yield select(getToken, entId, module)

    yield put(tableLoadingTrue(module, block, entId, { isLoading: true }))

    let queryParams = {}
    if (!_.isEmpty(action?.data?.changeData)) {
        const changeData = action?.data?.changeData

        queryParams = {
            'sort[]': _.map(changeData?.sorted, (val) => `${val?.id}${val.desc ? ':desc' : ':asc'}`),
            page: changeData?.pagination?.page,
            rows: changeData?.pagination?.rowsPerPage,
        }
    } else {
        // default query params from config
        queryParams = config?.api?.[module]?.[block]?.tables?.suppliedTenders?.qs || {}
    }

    yield put(loadTableDataRequest(module, block, entId, level, locale, token, queryParams))

    const response = yield race({
        success: take(LOAD_WON_TENDERS_TABLE_DATA_REQUEST_SUCCESS(entId)),
        failed: take(LOAD_WON_TENDERS_TABLE_DATA_REQUEST_FAILED(entId)),
    })

    if (response.failed) {
        yield put(tableLoadingFailed(module, block, entId, { isLoading: false, loaded: true, failed: true }))
        return null
    }

    const responseBody = response?.success?.payload?.response?.body

    yield put(
        tableDataReceived(module, block, entId, {
            loaded: true,
            data: responseBody?.data,
            dataLocale: locale,
            failed: false,
            query: {
                pagination: responseBody?.query?.pagination,
                sorted: _.reduce(
                    responseBody?.query?.sort?.sortedColumns,
                    (acc, val) => [
                        ...acc,
                        {
                            id: val?.columm,
                            desc: val?.direction === 'desc',
                        },
                    ],
                    []
                ),
            },
        })
    )

    yield put(tableLoadingFalse(module, block, entId, { isLoading: false }))

    return null
}

function* wonTendersSaveCustomDataCallSaga(action) {
    const blockKey = action?.data?.block
    if (blockKey !== config.modules.report.blocks.procurement.key) return null

    const module = action?.data?.module
    const entId = action?.data?.entId
    if (!module || !entId || !blockKey) return null

    const customData = yield select(getCustomData, module, blockKey, entId)
    const incomingChange = action?.data?.data || {}

    yield put(
        blockSaveCustomData(module, entId, blockKey, {
            ...customData,
            wonTenders: {
                ...(customData?.wonTenders || {}),
                ...incomingChange,
            },
        })
    )

    return null
}

export default function* wonTendersSaga() {
    yield all([
        takeLatest(LOAD_WON_TENDERS_TABLE_DATA, loadTableDataSaga),
        takeLatest(WON_TENDERS_TABLE_LOADING_TRUE, wonTendersSaveCustomDataCallSaga),
        takeLatest(WON_TENDERS_TABLE_LOADING_FALSE, wonTendersSaveCustomDataCallSaga),
        takeLatest(WON_TENDERS_TABLE_DATA_RECEIVED, wonTendersSaveCustomDataCallSaga),
        takeLatest(WON_TENDERS_TABLE_LOADING_FAILED, wonTendersSaveCustomDataCallSaga),
    ])
}
